const styles = {
  navigationContainer: {
    height: "100vh",
    width: "100vw",
    left: 0,
    right: 0,
    top: 0
  }
};

export default styles;
